import React from 'react';
import classnames from 'classnames';

export default function SquareDiv(props) {
  const {children = [], className = '', ...otherAttrs} = props;
  return (
    <div className={classnames(className, 'squareDiv')} {...otherAttrs}>
      <div className="squareDivInner">{children}</div>
    </div>
  );
}
